import React from 'react';
import { Helmet } from 'react-helmet';
import Menu from '../components/Menu';

const MenuPage = () => {
  return (
    <>
      <Helmet>
        <title>Menu</title>
      </Helmet>
      <Menu />
    </>
  );
};

export default MenuPage;
